module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', {
    staticClass: "u-margin-top-0 u-margin-bottom-30"
  }, [_vm._v("\n        Service - " + _vm._s(_vm.service.description) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid a-form-inputs"
  }, [_c('div', {
    staticClass: "flex-grid__item"
  }, [_c('control', {
    attrs: {
      "for": "service_description",
      "label": "Service Description"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.service.description),
      expression: "service.description"
    }, {
      name: "field-control",
      rawName: "v-field-control:service_description.required",
      value: ({
        type: 'text'
      }),
      expression: "{type:'text'}",
      arg: "service_description",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "id": "service_description",
      "name": "service_description",
      "type": "text"
    },
    domProps: {
      "value": (_vm.service.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.service, "description", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('service_description')
    }
  }, [_vm._v("\n                    The service description is required\n                ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "services_multiplicand",
      "label": "Services Multiplicand",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.service.multiplicand),
      expression: "service.multiplicand",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "field-control",
      rawName: "v-field-control:services_multiplicand.required",
      value: ({
        type: 'number',
        rules: 'min:0.01'
      }),
      expression: "{type:'number', rules:'min:0.01'}",
      arg: "services_multiplicand",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "min": "1",
      "id": "services_multiplicand",
      "type": "text"
    },
    domProps: {
      "value": (_vm.service.multiplicand)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.service, "multiplicand", _vm._n($event.target.value))
      }, function($event) {
        return _vm.updateServicePeriod()
      }],
      "focus": function($event) {
        _vm.service.multiplicand = _vm.service.multiplicand || ''
      },
      "blur": [function($event) {
        _vm.service.multiplicand = _vm.service.multiplicand || 0
      }, function($event) {
        return _vm.$forceUpdate()
      }]
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('servicesMultiplicand')
    }
  }, [_vm._v("\n                    The services multiplicand is required and has to be greater than 0\n                ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "services_start_date",
      "label": "Services Start Date"
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:services_start_date.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "services_start_date",
      modifiers: {
        "required": true
      }
    }],
    on: {
      "input": function($event) {
        return _vm.updateServicePeriod()
      }
    },
    model: {
      value: (_vm.service.servicesStartDate),
      callback: function($$v) {
        _vm.$set(_vm.service, "servicesStartDate", $$v)
      },
      expression: "service.servicesStartDate"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('services_start_date')
    }
  }, [_vm._v("\n                    The services start date is required and must be in the format DD/MM/YYYY\n                ")]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.servicesStartDateValidation
    }
  }, [_vm._v("\n                    The services start date must be after the date of Injury/Accident " + _vm._s(_vm.getClaimInfo('dateOfInjury')) + "\n                ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "mortality_multiplier",
      "label": "Adjust Multiplier for Mortality?"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.service.mortalityMultiplier),
      expression: "service.mortalityMultiplier"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "id": "mortality_multiplier",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.service, "mortalityMultiplier", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.updateServicePeriod()
      }]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("No")])])]), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--no-margin",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.deleteService
    }
  }, [_vm._v("Remove Services")])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item flex-grid--space-left"
  }, [_c('control', {
    attrs: {
      "for": "services_losses_for_life",
      "label": "Do Services Continue for Life?"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.service.lossesForLife),
      expression: "service.lossesForLife"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }],
    attrs: {
      "id": "services_losses_for_life",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.service, "lossesForLife", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.getServicesLifeExpectancy]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("No")])])]), _vm._v(" "), (_vm.service.lossesForLife) ? _c('life-expectancy', {
    attrs: {
      "label": "Claimant's 'But For' Life Expectancy",
      "person": _vm.thePerson,
      "date": _vm.theDate,
      "type": "deceased",
      "assumedSettlement": _vm.getClaimInfo('dateOfAssumedSettlement'),
      "stepValid": _vm.stepValid
    },
    on: {
      "update": _vm.updateLife
    }
  }) : _vm._e(), _vm._v(" "), _c('control', {
    attrs: {
      "for": "services_end_date",
      "label": "Services End Date"
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:services_end_date.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "services_end_date",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "disabled": _vm.service.lossesForLife
    },
    on: {
      "input": function($event) {
        return _vm.updateServiceEndDate()
      }
    },
    model: {
      value: (_vm.service.servicesEndDate),
      callback: function($$v) {
        _vm.$set(_vm.service, "servicesEndDate", $$v)
      },
      expression: "service.servicesEndDate"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('services_end_date')
    }
  }, [_vm._v("\n                    The services end date is required and must be in the format DD/MM/YYYY\n                ")]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.servicesEndDateValidation
    }
  }, [_vm._v("\n                    The services end date must be after the services start date  " + _vm._s(_vm.service.servicesStartDate) + "\n                ")])], 1), _vm._v(" "), (_vm.service.lossesForLife === false) ? _c('control', {
    attrs: {
      "for": "services_age_at_end_date",
      "label": "Age at End Date"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.service.ageAtEndDate),
      expression: "service.ageAtEndDate",
      modifiers: {
        "number": true
      }
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "field-control",
      rawName: "v-field-control:services_age_at_end_date.required",
      value: ({
        type: 'number',
        rules: 'min:0.01'
      }),
      expression: "{type:'number', rules:'min:0.01'}",
      arg: "services_age_at_end_date",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "min": "1",
      "id": "services_age_at_end_date",
      "type": "text"
    },
    domProps: {
      "value": (_vm.service.ageAtEndDate)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.service, "ageAtEndDate", _vm._n($event.target.value))
      }, function($event) {
        return _vm.updateServiceAge()
      }],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('services_age_at_end_date')
    }
  }, [_vm._v("\n                    The claimant's age at services end date is required and has to be greater than 0\n                ")])], 1) : _vm._e()], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-81622fc8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/personal-injury-claims/steps/other-future-losses/FutureService.vue
// module id = 1762
// module chunks = 0